import { useAuthContext } from 'auth/AuthContext';
import React from 'react';

interface LoggedOutContentProps {
  children: any;
}

export const LoggedOutContent = ({
  children,
}: LoggedOutContentProps): JSX.Element => {
  const { isAuthenticated } = useAuthContext();

  if (isAuthenticated) {
    return <></>;
  }

  return <>{children}</>;
};

export default LoggedOutContent;
